import {
  // createPaymentIntent,
  signupCompletedAndRedirectToDashboard,
  getCSRFToken,
} from 'api/signup';
import * as Sentry from '@sentry/react';
import { trackEvent } from 'v6/api/signup';

// export const initPaypal = async (cbInstance: any, setError: (error: any) => void) => {
//   try {
//     console.log('initPaypal', cbInstance);

//     const paypalHandler = await cbInstance.load("paypal");
//     console.log('paypalHandler', paypalHandler);

//     const payment_intent = await createPaymentIntent({ amount: 1000, currency_code: 'USD' });
//     console.log('payment_intent', payment_intent);

//     paypalHandler.setPaymentIntent(payment_intent);

//     paypalHandler.mountPaymentButton("#paypal-button", {
//       style: {
//         shape: "pill",
//         color: "white",
//         layout: "horizontal",
//         label: "paypal",
//       },
//     })
//       .then(() => {
//         return paypalHandler.handlePayment();
//       })
//       .then((intent: any) => console.log("success", intent))
//       .catch((error: any) => {
//         console.log(error);
//         setError(error.displayMessage)
//       });
//   } catch (error) {
//     console.log(error);

//   }
// };

export const openChargebeeModal = async (
  cbInstance: any,
  setError: (error: any) => void,
  currency: string,
  plan: string,
  _id: string,
  coupon_ids: string[] | null,
  billingPeriod: string,
  numberAccounts: number,
) => {
  cbInstance.openCheckout({
    layout: 'in_app',
    hostedPage: async function () {
      const CSRFToken = await getCSRFToken();

      return fetch('/signup/v2/getHostedCheckoutPage', {
        headers: {
          // eslint-disable-next-line no-useless-computed-key
          ['X-XSRF-TOKEN']: CSRFToken,
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify({
          _id,
          plan,
          coupon_ids,
          currency,
          billingPeriod,
          numberAccounts,
          token: 'token',
        }),
      })
        .then(response => response.json())
        .then(response => {
          trackEvent({
            event: 'sign_up-chargebee_modal-view-page',
          });

          return response?.hostedData;
        })
        .catch(e => {
          Sentry.captureException(e);
        });
    },
    success: async function (hostedPageId: string) {
      const CSRFToken = await getCSRFToken();

      const result = await fetch('/signup/v2/acknowledgeHostedPage', {
        headers: {
          // eslint-disable-next-line no-useless-computed-key
          ['X-XSRF-TOKEN']: CSRFToken,
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify({ pageId: hostedPageId, _id }),
      }).then(response => response.json());

      if (result.action === 'ok') {
        signupCompletedAndRedirectToDashboard(plan, result.user._id);
      } else {
        alert('something is wrong, please try again later.');
      }
    },
    error: function (error: any) {
      console.error(error);
      setError(error);
    },
    close: function () {
      // nothing to do
    },
  });
};
